module.exports = __webpack_public_path__ + "685284f0d29e1b58e059896c08bd3c75.svg";